export enum TirPmDropdownSizeEnum {
  /**Обычный размер */
  Regular = "Regular",
  /**Малый размер */
  Light = "Light",
}
